module.exports = "/_next/static/images/video_id_7094055494230330670-8c723d3b26ef209269a3af95a23a887a.jpg";